var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGenerative = function SvgGenerative(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#E5E5E5",
    strokeLinejoin: "round",
    d: "M7.85 12.185c2.44-.162 4.383-2.134 4.543-4.608a12 12 0 0 0 0-1.47c-.16-2.475-2.103-4.446-4.543-4.609a19 19 0 0 0-2.533 0C2.877 1.661.933 3.632.773 6.107a12 12 0 0 0 0 1.47c.059.901.457 1.736.927 2.44.272.494.092 1.11-.192 1.647-.204.388-.306.582-.224.722s.265.144.632.153c.726.018 1.216-.188 1.604-.474.22-.163.33-.244.406-.253s.226.052.525.175c.268.11.58.179.866.198.83.055 1.7.055 2.533 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E5E5E5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m3.957 8.75 1.074-3.223a.405.405 0 0 1 .768 0L6.874 8.75m1.75-3.5v3.5M4.54 7.583h1.75"
  })));
};
export default SvgGenerative;